<template>
    <div class="reset-password-page d-flex flex-column min-vh-100">
      <div class="container flex-grow-1 d-flex justify-content-center align-items-center">
        <div class="col-md-4">
          <div class="card border-0">
            <div class="card-body p-4">
              <h3 class="fw-bold mb-4">Set New Password</h3>

              <div class="text-start mb-3">
                <label for="password" class="form-label">New Password<span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    :type="showPassword ? 'text' : 'password'"
                    class="form-control"
                    id="password"
                    v-model="password"
                    placeholder="***********"
                  >
                  <span class="input-group-text bg-white" @click="showPassword = !showPassword">
                    <i :class="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                  </span>
                </div>
                <div v-if="passwordError" class="d-flex align-items-center text-danger small mt-1">
                  <i class="fas fa-exclamation-triangle me-1"></i>
                  <span>{{ passwordError }}</span>
                </div>
              </div>

              <div class="text-start mb-4">
                <label for="confirmPassword" class="form-label">Confirm Password<span class="text-danger">*</span></label>
                <div class="input-group">
                  <input
                    :type="showConfirmPassword ? 'text' : 'password'"
                    class="form-control"
                    id="confirmPassword"
                    v-model="password_confirmation"
                    placeholder="***********"
                  >
                  <span class="input-group-text bg-white" @click="showConfirmPassword = !showConfirmPassword">
                    <i :class="showConfirmPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                  </span>
                </div>
                <div v-if="confirmPasswordError" class="d-flex align-items-center text-danger small mt-1">
                  <i class="fas fa-exclamation-triangle me-1"></i>
                  <span>{{ confirmPasswordError }}</span>
                </div>
              </div>

              <div v-if="apiError" class="d-flex align-items-center text-danger small mb-3">
                <i class="fas fa-exclamation-triangle me-1"></i>
                <span>{{ apiError }}</span>
              </div>
              <div v-if="successMessage" class="d-flex align-items-center text-success small mb-3">
                <i class="fas fa-check-circle me-1"></i>
                <span>{{ successMessage }}</span>
              </div>

              <button class="btn btn-success btn-lg w-100" @click="submitForm">Save Change</button>
            </div>
          </div>
        </div>
      </div>

      <footer class="footer text-center py-3">
        <small class="text-muted">
          © PT Anugrah Multi Remittance 2025 |
          <a href="#" class="text-decoration-none text-muted">Terms & Conditions</a> |
          <a href="#" class="text-decoration-none text-muted">Privacy Policy</a>
        </small>
      </footer>
    </div>
  </template>

  <script>
import { onBeforeMount, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { resetPassword } from '../../api/auth';
import { buildFormData } from '../../utils/param-builder';

  export default {
    data() {
      return {
        password: '',
        password_confirmation: '',
        showPassword: false,
        showConfirmPassword: false,
        passwordError: '',
        confirmPasswordError: '',
        apiError: '',
        successMessage: ''
      }
    },
    created() {
        const resetPasswordToken = this.$route.params.resetPasswordToken;
        if (resetPasswordToken) {
            this.$store.commit("auth/setResetPasswordToken", resetPasswordToken);
        }
    },
    computed: {
        resetPasswordToken() {
        return this.$store.state.auth.reset_password_token;
        }
    },
    methods: {
        async submitForm() {
          // Clear previous errors
          this.passwordError = '';
          this.confirmPasswordError = '';
          this.apiError = '';
          this.successMessage = '';

          if (!this.validate()) {
            return;
          }

          const body = {
              reset_password_token: this.resetPasswordToken,
              password: this.password,
              password_confirmation: this.password_confirmation
          };

          try {
              const formData = buildFormData(body);
              const response = await resetPassword(formData);

              this.successMessage = response.message;
              setTimeout(() => {
                this.$router.push({ name: 'ResetPasswordNotify' });
              }, 1500);
          } catch (error) {
              const errorMessage = error?.response?.data?.message || "An unexpected error occurred. Please try again.";
              this.apiError = errorMessage;
          }
        },

        validate() {
          let isValid = true;

          if (!this.password || !this.password_confirmation) {
            if (!this.password) {
              this.passwordError = "Password is required.";
            }
            if (!this.password_confirmation) {
              this.confirmPasswordError = "Confirm password is required.";
            }
            isValid = false;
          }

          if (this.password && this.password.length < 8) {
            this.passwordError = "Password must be at least 8 characters long";
            isValid = false;
          }

          if (this.password) {
            const passwordRegex = /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+=\-[\]{};:"\\|,.<>/?])[A-Za-z\d!@#$%^&*()_+=\-[\]{};:"\\|,.<>/?]{8,}$/;
            if (!passwordRegex.test(this.password)) {
              this.passwordError = "Password must contain at least one uppercase letter, one number, and one special character";
              isValid = false;
            }
          }

          if (this.password && this.password_confirmation && this.password !== this.password_confirmation) {
            this.confirmPasswordError = "Passwords do not match.";
            isValid = false;
          }

          return isValid;
        }
    },
    setup() {
    const store = useStore();
    const body = document.getElementsByTagName("body")[0];

    onBeforeMount(() => {
      store.state.hideConfigButton = true;
      store.state.showNavbar = false;
      store.state.showSidenav = false;
      store.state.showFooter = false;
      body.classList.remove("bg-gray-100");
    });

    onBeforeUnmount(() => {
      store.state.hideConfigButton = false;
      store.state.showNavbar = true;
      store.state.showSidenav = true;
      store.state.showFooter = true;
      body.classList.add("bg-gray-100");
    });
  },
  }
  </script>

  <style scoped>
  .reset-password-page {
    background-color: #F4F6F6;
    min-height: 100vh;
  }

  .card {
    border-radius: 0.5rem;
  }

  .input-group-text {
    cursor: pointer;
  }

  .footer {
    background-color: #F4F6F6;
    width: 100%;
  }
  </style>
